module.exports = __webpack_public_path__ + "img/americanexpress.e5bf0c8d.svg";